import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyle = makeStyles((theme) => ({
  root: {
    flex: 1,
    width: '100%',
  },
  header: {
    display: 'flex',
  },
  title: {
    flex: '1',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: '#192542',
    ['& h1']: {
      fontSize: '2rem',
      lineHeight: 1,
      fontWeight: 400,
      marginBottom: '0.5rem',
    },
    ['& p']: {
      fontSize: '1rem',
      lineHeight: '1.3125rem',
      color: '#818b9d',
    },
  },
  reports: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
  },
  empty: {
    textAlign: 'center',
    padding: 16,
  },
  listItem: {
    background: '#ffffff',
    marginBottom: 16,
    color: '#192542',
    display: 'block',
    border: '1px solid #f0f0f0',
  },
  secondListItemText: {
    ['& p']: {
      marginTop: 'auto',
      fontSize: 'smaller',
    },
  },
  '@media screen and (min-width: 720px)': {
    listItem: {
      display: 'flex',
    },
    secondListItemText: {
      ['& p']: { marginLeft: 'auto', width: 120, marginTop: '-1.2rem' },
    },
  },
}));

export default useStyle;
